import * as React from "react";
const CaretRight = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 18", fill: "currentColor", width: size || "12", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 9 3 5v8l6-4Z" }));
CaretRight.displayName = "CaretRight";
var CaretRight_default = CaretRight;
export {
  CaretRight_default as default
};
